import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const RupeeCircleOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.17 12c0-4.51-3.67-8.17-8.17-8.17S3.83 7.5 3.83 12s3.66 8.17 8.17 8.17 8.17-3.66 8.17-8.17ZM2.23 12c0-5.39 4.38-9.77 9.77-9.77S21.77 6.6 21.77 12c0 5.4-4.37 9.77-9.77 9.77-5.4 0-9.77-4.38-9.77-9.77Zm10.8-3.55h2.17v-.89H8.8v1.37h2.04c.74 0 1.3.35 1.47.96H8.8v.89h3.49c-.2.6-.74.97-1.45.97H8.8v1.37h1.45l1.97 3.32h1.8l-2.17-3.49c.97-.16 1.92-.88 2.08-2.17h1.27v-.89h-1.28c-.1-.57-.41-1.08-.89-1.44Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default RupeeCircleOutlined
